import { MoDataStore } from "ui-common";
import { SiteStoreMockPlugin } from "./mocks/SiteStoreMockPlugin";

export class SiteStore extends MoDataStore {

  static readonly defaultConfig = {
    mockPlugin: SiteStoreMockPlugin,

    api: {
      service: 'sites',
      list: 'getSites',
      get: 'getSite',
    },
  };

  async getSites(customerId: string) {
    const mocks = new SiteStoreMockPlugin({} as any)
    if (this.config.mock) {
      return mocks.getSites(customerId);
    }
    let response;
    try {
      response = await this.callApiMethod({
        service: 'sites',
        name: 'getSites',
        pathParams: { customerId },
      }, {})
        .then((sites) => {
          return sites.content;
        }).catch((err) => `Error ${err}`);
    } catch (_error) { /* empty */ }
    return response;
  }
}